module.exports = __webpack_public_path__ + "img/adhka-yx1zn.013.8e78b40b.jpeg";